// HowItWorksSection.jsx
import React from 'react';
import './HowItWorksSection.css';
import { Card, CardContent } from './ui/card';
import { ArrowRight } from 'lucide-react';
import { mockHowItWorks } from './mock';

const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="hiw-section">
      <div className="hiw-container">
        <div className="hiw-header">
          <div className="hiw-badge">How It Works</div>
          <h2 className="hiw-title">
            Simple Process,
            <span className="hiw-highlight"> Powerful Results</span>
          </h2>
          <p className="hiw-description">
            Our streamlined 4-step process ensures quick resolution of your technical issues with minimal disruption to your workflow.
          </p>
        </div>

        <div className="hiw-grid-wrapper">
          <div className="hiw-grid">
            {mockHowItWorks.map((step, index) => (
              <div key={step.step} className="hiw-step-container">
                <Card className="hiw-card">
                  <CardContent className="hiw-card-content">
                    <div className="hiw-step-circle">{step.step}</div>
                    <h3 className="hiw-step-title">{step.title}</h3>
                    <p className="hiw-step-description">{step.description}</p>
                  </CardContent>
                </Card>

                {/* Arrow Between Steps */}
                {index < mockHowItWorks.length - 1 && (
                  <div className="hiw-arrow">
                    <ArrowRight className="hiw-arrow-icon" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
